<template>
  <div class="homeChild" ref="homeChild">
    <div class="title">{{ homeChildTitle }}</div>
    <div class="content">
      <slot name="weatherSummary"></slot>
      <slot name="scenicSpotsWeather"></slot>
      <slot name="shortTime"></slot>
      <slot name="airQuality"></slot>
      <slot name="sevenDaysWeather"></slot>
      <slot name="aroundCityWeather"></slot>
      <slot name="TransportationHub"></slot>
      <slot name="weatherWeibo"></slot>
      <slot name="areaAlarm"></slot>
      <slot name="weiboGroup"></slot>
      <slot name="lifePercent"></slot>
      <slot name="stationWeather"></slot>
    </div>
  </div>
</template>

<script>

export default {
  props: ['containWidth', 'title'],
  computed: {
    homeChildWidth () {
      return this.containWidth
    },
    homeChildTitle () {
      return this.title
    }
  },
  methods: {
    setContainWidth () {
      this.$refs.homeChild.style.width = this.homeChildWidth + 'px'
    }
  },
  mounted () {
    this.setContainWidth()
  }
}
</script>

<style lang="less" scoped>
.homeChild {
  margin-top: 20px;
  border-radius: 7px;
  background-color: #fffddf;
  .title {
    height: 48px;
    padding-left: 10px;
    background-color: #f8d276;
    line-height: 48px;
    font-size: 18px;
    text-align: left;
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
  }
  .content {
    padding: 5px;
    border-bottom-left-radius: 7px;
    border-bottom-right-radius: 7px;
  }
}
</style>
